(() => {
  const body = document.body;
  const header = document.querySelector('[data-header]');
  const motionEnabled = true;

  // Header transforms into a solid burgundy bar after the hero.
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 35);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Reveal-on-scroll.
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  // Craftsmanship counter.
  const counters = document.querySelectorAll('[data-count]');
  const counterObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count || '30', 10);
      let start = 0;
      const duration = 1000;
      const startTime = performance.now();
      const tick = now => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.firstChild.textContent = Math.round(start + (target - start) * eased);
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 }) : null;
  counters.forEach(el => counterObserver ? counterObserver.observe(el) : (el.firstChild.textContent = el.dataset.count));

  // Mobile menu.
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const openMenu = document.querySelector('[data-menu-open]');
  const closeMenu = document.querySelector('[data-menu-close]');
  const setMenu = open => {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('menu-open', open);
  };
  openMenu?.addEventListener('click', () => setMenu(true));
  closeMenu?.addEventListener('click', () => setMenu(false));
  mobileMenu?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  // Search panel.
  const searchPanel = document.querySelector('[data-search-panel]');
  document.querySelector('[data-search-open]')?.addEventListener('click', () => {
    const open = !searchPanel.classList.contains('is-open');
    searchPanel.classList.toggle('is-open', open);
    searchPanel.setAttribute('aria-hidden', String(!open));
    if (open) searchPanel.querySelector('input')?.focus();
  });

  // Cart drawer.
  const drawer = document.querySelector('[data-cart-drawer]');
  const setDrawer = open => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('drawer-open', open);
  };
  document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', () => setDrawer(true)));
  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', () => setDrawer(false)));

  // Desktop cursor effect.
  if (window.matchMedia('(pointer:fine)').matches && true) {
    const cursor = document.querySelector('.site-cursor');
    const dot = document.querySelector('.site-cursor-dot');
    let x = -100, y = -100, dx = -100, dy = -100;
    window.addEventListener('mousemove', e => {
      x = e.clientX; y = e.clientY;
      body.classList.add('cursor-active');
      if (dot) { dot.style.left = x + 'px'; dot.style.top = y + 'px'; }
    });
    const loop = () => {
      dx += (x - dx) * .16; dy += (y - dy) * .16;
      if (cursor) { cursor.style.left = dx + 'px'; cursor.style.top = dy + 'px'; }
      requestAnimationFrame(loop);
    };
    loop();
    document.querySelectorAll('a,button,.product-card,.collection-card').forEach(el => {
      el.addEventListener('mouseenter', () => body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave', () => body.classList.remove('cursor-hover'));
    });
  }

  // Gentle parallax on large editorial images.
  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    const sections = document.querySelectorAll('[data-parallax-section]');
    const parallax = () => {
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const image = section.querySelector('.hero__image, .heritage__image');
        if (!image || rect.bottom < 0 || rect.top > innerHeight) return;
        const offset = (innerHeight / 2 - (rect.top + rect.height / 2)) * .025;
        image.style.transform = `translateY(${offset}px) scale(1.03)`;
      });
    };
    window.addEventListener('scroll', parallax, { passive: true });
    parallax();
  }

  // Product gallery carousel: cycle through photos instead of stacking them.
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const current = gallery.querySelector('[data-gallery-current]');
    if (slides.length < 2) return;
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));if(!active)slide.querySelectorAll('video').forEach(v=>v.pause())});
      thumbs.forEach((thumb,i)=>{const active=i===index;thumb.classList.toggle('is-active',active);thumb.setAttribute('aria-selected',String(active))});
      if(current) current.textContent=String(index+1).padStart(2,'0');
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    gallery.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')show(index-1);if(e.key==='ArrowRight')show(index+1)});
  });

  // Reliable Shopify product add-to-cart.
  // We add the selected variant through Shopify's cart endpoint, refresh the cart,
  // then open the drawer. If anything unexpected happens, the customer is taken
  // to the cart rather than being left on a loading button.
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const productPage = form.closest('.product-page');
    const variantInput = form.querySelector('[data-variant-id]');
    const variantData = productPage?.querySelector('[data-product-variants]');
    const selects = [...form.querySelectorAll('[data-option-index]')];
    const errorEl = form.querySelector('[data-product-form-error]');
    const submit = form.querySelector('.product-submit');
    const priceEl = productPage?.querySelector('[data-product-price]');
    let variants = [];

    try { variants = variantData ? JSON.parse(variantData.textContent) : []; } catch (e) {}

    const selectedVariant = () => {
      if (!variants.length) return null;
      if (!selects.length) {
        return variants.find(v => String(v.id) === String(variantInput?.value)) ||
               variants.find(v => v.available) || variants[0];
      }
      const values = selects.map(s => s.value);
      return variants.find(v => v.options.every((value, i) => String(value) === String(values[i]))) || null;
    };

    const formatMoney = cents => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: ''
        }).format(Number(cents) / 100);
      } catch (e) {
        return `$${(Number(cents) / 100).toFixed(2)}`;
      }
    };

    const setButtonLabel = label => {
      if (!submit) return;
      const labelNode = submit.querySelector('[data-button-label]');
      if (labelNode) labelNode.textContent = label;
      else submit.textContent = label;
    };

    const syncVariant = () => {
      const variant = selectedVariant();

      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (submit) submit.disabled = true;
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'That combination is currently unavailable.';
        }
        return null;
      }

      if (variantInput) variantInput.value = String(variant.id);
      if (submit) {
        submit.disabled = !variant.available;
        setButtonLabel(variant.available ? 'Add to bag' : 'Sold out');
      }
      if (priceEl && variant.price != null) priceEl.textContent = formatMoney(variant.price);
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      return variant;
    };

    selects.forEach(select => select.addEventListener('change', syncVariant));
    syncVariant();

    form.addEventListener('submit', async event => {
      event.preventDefault();

      const variant = syncVariant();
      if (!variant || !variant.available || !variantInput?.value) return;

      const quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      const payload = new URLSearchParams();
      payload.set('id', String(variantInput.value));
      payload.set('quantity', String(quantity));

      if (submit) {
        submit.disabled = true;
        submit.classList.add('is-loading');
        setButtonLabel('Adding…');
      }
      if (errorEl) errorEl.hidden = true;

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json'
          },
          body: payload.toString()
        });

        const addData = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) {
          throw new Error(addData.description || addData.message || 'Shopify could not add this piece to your bag.');
        }

        const cartResponse = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();

        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        const drawerEl = document.querySelector('[data-cart-drawer]');
        if (!drawerEl) {
          window.location.href = '';
          return;
        }

        const items = drawerEl.querySelector('[data-cart-items]');
        const headCount = drawerEl.querySelector('[data-cart-drawer-count]');
        const foot = drawerEl.querySelector('.cart-drawer__foot');

        if (headCount) headCount.textContent = cart.item_count;

        if (items) {
          if (!cart.items.length) {
            items.innerHTML = '<div class="empty-state"><p>Your bag is currently empty.</p></div>';
          } else {
            items.innerHTML = cart.items.map(item => {
              const image = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=180' : '';
              return `
                <div class="cart-item">
                  ${image ? `<a href="${item.url}"><img src="${image}" alt=""></a>` : '<div></div>'}
                  <div class="cart-item__info">
                    <a href="${item.url}">${item.product_title}</a>
                    <small>${item.quantity} × ${formatMoney(item.final_line_price)}</small>
                  </div>
                </div>`;
            }).join('');
          }
        }

        if (foot) {
          foot.hidden = cart.item_count === 0;
          const total = foot.querySelector('.cart-total strong');
          if (total) total.textContent = formatMoney(cart.total_price);
        }

        drawerEl.classList.add('is-open');
        drawerEl.setAttribute('aria-hidden', 'false');
        body.classList.add('drawer-open');

        if (submit) { setButtonLabel('Added to bag ✓'); submit.classList.add('is-added'); }
        setTimeout(() => { if (submit) { submit.classList.remove('is-added'); setButtonLabel('Add to bag'); } }, 1800);
      } catch (err) {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || 'We could not add this piece. Please try again.'; }
        if (submit) { submit.classList.remove('is-loading'); submit.disabled = false; setButtonLabel('Try again'); }
      } finally {
        const latest = syncVariant();
        if (submit && !document.querySelector('[data-cart-drawer].is-open')) {
          submit.classList.remove('is-loading');
          submit.disabled = !latest || !latest.available;
        } else if (submit) {
          submit.classList.remove('is-loading');
        }
      }
    });
  });

  // Hero responds subtly to pointer movement: fabric-inspired geometry drifts with the cursor.
  const hero = document.querySelector('.hero');
  if (hero && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let frame;
    hero.addEventListener('pointermove', event => {
      const rect = hero.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        hero.style.setProperty('--pointer-x', `${x * 18}px`);
        hero.style.setProperty('--pointer-y', `${y * 12}px`);
      });
    });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--pointer-x', '0px');
      hero.style.setProperty('--pointer-y', '0px');
    });
  }

})();

  // Cart drawer controls: remove items and change quantities without leaving the page.
  async function refreshCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const itemsEl = drawer.querySelector('[data-cart-items]');
    const foot = drawer.querySelector('.cart-drawer__foot');
    const totalEl = drawer.querySelector('[data-cart-total]');

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.length
        ? cart.items.map(item => `
          <div class="cart-item" data-line-key="${item.key}">
            ${item.image ? `<a class="cart-item__image" href="${item.url}"><img src="${item.image}&width=180" alt=""></a>` : ''}
            <div class="cart-item__info">
              <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}
              <strong>${(item.final_line_price / 100).toLocaleString(undefined, {style:'currency', currency:'${shop.currency}'})}</strong>
              <div class="cart-item__controls">
                <button type="button" data-cart-decrease data-line-key="${item.key}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-increase data-line-key="${item.key}" aria-label="Increase quantity">+</button>
                <button type="button" class="cart-item__remove" data-cart-remove data-line-key="${item.key}">Remove</button>
              </div>
            </div>
          </div>
        `).join('')
        : '<div class="empty-state"><p>Your bag is currently empty.</p><a class="button button--dark" href="/collections/all">Continue shopping</a></div>';
    }

    if (totalEl) totalEl.textContent = (cart.total_price / 100).toLocaleString(undefined, {style:'currency', currency:'${shop.currency}'});
    if (foot) foot.hidden = cart.item_count === 0;
  }

  document.addEventListener('click', async event => {
    const remove = event.target.closest('[data-cart-remove]');
    const increase = event.target.closest('[data-cart-increase]');
    const decrease = event.target.closest('[data-cart-decrease]');
    const control = remove || increase || decrease;
    if (!control) return;

    event.preventDefault();
    const key = control.dataset.lineKey;
    if (!key) return;

    try {
      if (remove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: key, quantity: 0})
        });
      } else {
        const cartResponse = await fetch('/cart.js', {headers: {'Accept': 'application/json'}});
        const cart = await cartResponse.json();
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const quantity = Math.max(0, item.quantity + (increase ? 1 : -1));

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: key, quantity})
        });
      }

      await refreshCartDrawer();
    } catch (error) {
      console.error('Cart update failed:', error);
    }
  });

